import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../../components/ui/Card';
import { CalendarIcon, ClipboardDocumentListIcon, DocumentTextIcon, TableCellsIcon } from '@heroicons/react/24/outline';

const MarketingManagementPage = () => {
  const navigate = useNavigate();

  const menuItems = [
    {
      title: 'Mailing Planner',
      description: 'Mailing planlarını yönetin ve takibini yapın.',
      icon: <ClipboardDocumentListIcon className="w-8 h-8 text-blue-500" />,
      path: '/marketing-management/mailing-planner',
      color: 'bg-blue-50 dark:bg-blue-900/20'
    },
    {
      title: 'Mailing Calendar',
      description: 'Mailing takvimini görüntüleyin.',
      icon: <CalendarIcon className="w-8 h-8 text-green-500" />,
      path: '/marketing-management/mailing-calendar',
      color: 'bg-green-50 dark:bg-green-900/20'
    },
    {
      title: 'Content Planner',
      description: 'İçerik planlarını yönetin ve takibini yapın.',
      icon: <DocumentTextIcon className="w-8 h-8 text-purple-500" />,
      path: '/marketing-management/content-planner',
      color: 'bg-purple-50 dark:bg-purple-900/20'
    },
    {
      title: 'Content Calendar',
      description: 'İçerik takvimini görüntüleyin.',
      icon: <CalendarIcon className="w-8 h-8 text-orange-500" />,
      path: '/marketing-management/content-calendar',
      color: 'bg-orange-50 dark:bg-orange-900/20'
    },
    {
      title: 'Content Presentation Table',
      description: 'Yönetim sunumu için gelişmiş içerik tablo görünümü.',
      icon: <TableCellsIcon className="w-8 h-8 text-cyan-500" />,
      path: '/marketing-management/content-presentation',
      color: 'bg-cyan-50 dark:bg-cyan-900/20'
    }
  ];

  return (
    <div className="p-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
          Marketing Management
        </h1>
        <p className="text-gray-600 dark:text-gray-400">
          Mailing ve pazarlama içeriklerinizi buradan yönetebilirsiniz.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {menuItems.map((item, index) => (
          <Card
            key={index}
            className="cursor-pointer hover:shadow-lg transition-shadow duration-300 border border-gray-200 dark:border-gray-700"
            onClick={() => navigate(item.path)}
          >
            <div className={`p-6 rounded-t-lg ${item.color}`}>
              {item.icon}
            </div>
            <div className="p-6">
              <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                {item.description}
              </p>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default MarketingManagementPage;

